import * as yup from "yup"

export const SEO_SCHEMA = yup.object().shape({
  title: yup.string().max(65),
  description: yup.string().max(165),
  image: yup.object(),
})
